<template>
    <div class="table_wrapper min-h-full" v-if="show && visibility">
        <div class="title_table ">
            <div class="title_settings">
                <div class="table_title capitalize">{{ table_title }}</div>
                <div class="flex">
                    <AppSearch @search="getSearch" />
                    <i class="fa-regular fa-circle-xmark fa-xl" @click="close"></i>
                </div>
            </div>
        </div>
        <table class="table-auto w-full md:w-auto">
            <thead>
                <tr>
                    <th v-for="(value, key) in filteredTableData[0]" :key="key">{{ key }}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(row, rowIndex) in mergedTableData" :key="rowIndex" @click="handleRowClick(row)"
                    :class="{ 'selected': selectedRow.id === row.id, 'nonselected': selectedRow.id !== row.id }">
                    <td v-for="(value, key) in row" :key="key" :style="{ 'background-color': row.cor ? row.cor : '' }">
                        {{ value }}</td>
                </tr>
            </tbody>
        </table>
        <div class="pagination" style="display: flex; gap: 0.5rem;">
            <button @click="prevPage" :disabled="currentPage === 1" style="cursor: pointer; color: #ff9b05;">
                < </button>
                    <span>{{ currentPage }} de {{ totalPages }}</span>
                    <button @click="nextPage" :disabled="currentPage === totalPages"
                        style="cursor: pointer; color: #ff9b05;">></button>
        </div>
    </div>
</template>

<script>
import AppSearch from '@/components/search.vue'
export default {
    name: 'AppTableSimples',
    components: {
        AppSearch,
    },
    props: {
        table_data: {
            type: Array,
            default: () => []
        },
        table_title: {
            type: String,
            default: () => "Table Title"
        },
        show: {
            type: Boolean,
            default: () => false
        },
        visibility: {
            type: Boolean,
            default: () => false
        },
        notificacao: {
            type: Object,
            default: () => ({})
        }

    },
    watch: {
        table_data: {
            handler(newVal) {
                if (newVal.length > 0) {
                    this.filter_data = this.addTrueValues(newVal[0]);
                }
            },
            immediate: true
        }
    },
    methods: {
        handleRowClick(row) {
            this.selectedRow = row;
            this.$emit('row-clicked', row);


        },
        delete_onClick(row) {
            this.$emit("delete_data", row);
        },
        close() {
            this.$emit('close');
        },
        addTrueValues(obj) {
            let newObj = {};
            for (let key in obj) {
                newObj[key] = true;
            }
            return newObj;
        },
        updateFilter({ property, value }) {
            this.filter_data[property] = value;
        },
        getSearch(text) {
            this.search_text = text;
        },
        applySearchFilter(data) {
            if (!this.search_text) {
                return data;
            }

            return data.filter(row => {
                for (let key in row) {
                    if (Object.prototype.hasOwnProperty.call(row, key) && typeof row[key] === 'string' && row[key].toLowerCase().includes(this.search_text.toLowerCase())) {
                        return true;
                    }
                    else if (Object.prototype.hasOwnProperty.call(row, key) && typeof row[key] === 'number' && row[key] == parseInt(this.search_text)) {
                        return true;
                    }
                }
                return false;
            });
        },
        nextPage() {
            if (this.currentPage < this.totalPages) {
                this.currentPage++;
            }
        },
        prevPage() {
            if (this.currentPage > 1) {
                this.currentPage--;
            }
        },

    },
    data() {
        return {
            filter_data: {},
            search_text: "",
            perPage: 10,
            currentPage: 1,
            selectedRow: {},
        }
    },
    computed: {
        perPageOptions() {
            return [5, 10, 15, 20];
        },
        filteredTableData() {
            return this.table_data.map(row => {
                let filteredRow = {};
                for (let key in row) {
                    if (this.filter_data[key]) {
                        filteredRow[key] = row[key];
                    }
                }
                return filteredRow;
            });
        },
        searchedTableData() {
            return this.applySearchFilter(this.table_data);
        },
        totalPages() {
            return Math.ceil(this.searchedTableData.length / this.perPage);
        },
        displayedTableData() {
            const startIndex = (this.currentPage - 1) * this.perPage;
            const endIndex = startIndex + this.perPage;
            return this.searchedTableData.slice(startIndex, endIndex);
        },

        mergedTableData() {
            const mergedData = [];
            const filteredData = this.filteredTableData;
            const displayedData = this.displayedTableData;

            if (filteredData && filteredData.length > 0) {
                const filteredKeys = Object.keys(filteredData[0]);

                for (let i = 0; i < displayedData.length; i++) {
                    const row = displayedData[i];
                    const mergedRow = {};

                    for (const key of filteredKeys) {
                        mergedRow[key] = row[key];
                    }

                    mergedData.push(mergedRow);
                }
            }

            return mergedData;
        }

    }
}
</script>



<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Abril+Fatface&family=Inter&family=Montserrat:wght@600&family=Poppins:wght@600&display=swap');

.table_wrapper {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    background-color: rgba(93, 93, 152, 0.45);
    padding: 2rem;
    border-radius: 8px;
    justify-content: center;
    align-items: center;
    color: white;
    overflow-x: auto;

}

.title_table {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.title_settings {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
}

.table_title {
    font-size: 16px;
    color: #ff9b05;
}

.close_btn_div {
    display: flex;
    align-self: flex-end;
    gap: 0.3rem;
}

.table_wrapper table {
    color: white;
    table-layout: fixed;
    min-width: 600px;
    width: 100%;
    max-height: 253px;
    overflow-y: auto;
    gap: 1rem;
    border-collapse: separate;
    border-spacing: 0 0.3em;
}

thead {
    background-color: #4d4d6c;
    width: 100%;
    height: 25px;
    border-radius: 8px;

}

th {
    font-size: 14px;
    text-align: left;
    padding-left: 0.5rem;
    text-transform: capitalize;
    font-weight: 400;

}

tbody {
    width: 100%;
}


tbody tr {
    height: 25px;
    cursor: pointer;
    margin-bottom: 1em;
}

tbody tr:hover td {
    background: #c67700;
}

/* td {
    color: white;
    font-size: 10px;
    background-color: #626288;
    text-align: left;
    padding-left: 0.5rem;
    border: none;
    
}
*/

.nonselected td {
    /* color: white; */
    background-color: #626288;
    font-size: 10px;
    text-align: left;
    padding-left: 0.5rem;
    /* white-space: nowrap; */
    border: none;

    /* Add this line */
}

.selected td {
    background-color: #c67700;
    font-size: 10px;
    /* background-color: #626288; */
    text-align: left;
    padding-left: 0.5rem;
    /* white-space: nowrap; */
    border: none;
    /* color: #ff9b05; */
}

td:first-child,
th:first-child {
    border-radius: 8px 0 0 8px;
}

td:last-child,
th:last-child {
    border-radius: 0 8px 8px 0;
}

@media (max-width: 768px) {
    .table_wrapper {
        /* Styles for screens smaller than 768px */
        font-size: 0.8em;
    }
}

@media (min-width: 769px) {
    .table_wrapper {
        /* Styles for screens larger than 768px */
        font-size: 1em;
    }
}
</style>
